module.exports = __webpack_public_path__ + "img/48_14.8e460b73.png";